module.exports = "/_next/static/images/apple-icon-60x60-3e4f29cff5c62c27e0faefcf09c0e9d0.png";